module.exports = __webpack_public_path__ + "img/document.e6b16ea7.svg";